var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNuxtJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 191,
    viewBox: "0 0 256 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8912 183.615C77.7013 183.279 77.5321 182.932 77.3847 182.575C76.3622 180.21 76.0474 177.599 76.4783 175.058H15.9931L105.881 16.874L135.391 68.7489L143.948 53.6077L118.224 8.29039C117.504 6.98419 113.159 0 105.668 0C102.283 0 97.4309 1.46615 93.4856 8.39702L2.42462 168.5C1.65156 169.886 -2.10711 177.164 1.6249 183.615C3.33096 186.547 6.95634 190.039 14.9535 190.039H91.2198C83.2759 190.039 79.5972 186.6 77.8912 183.615Z",
    fill: "#01C58E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.242 168.5L178.415 36.6802C177.642 35.294 173.324 28.2832 165.806 28.2832C162.421 28.2832 157.569 29.7227 153.624 36.6536L143.947 53.6076L152.558 68.7488L165.886 45.1572L239.913 175.058H211.763C212.123 177.205 211.921 179.409 211.177 181.456C211.02 181.907 210.824 182.344 210.59 182.762L210.35 183.242C206.565 189.693 198.381 190.039 196.782 190.039H240.82C242.446 190.039 250.603 189.693 254.388 183.242C256.067 180.309 257.267 175.378 253.242 168.5Z",
    fill: "#108775"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.351 183.241L210.591 182.762C210.824 182.344 211.021 181.907 211.177 181.455C211.922 179.409 212.124 177.205 211.764 175.058C211.349 172.742 210.518 170.52 209.311 168.5L152.612 68.7487L143.948 53.6074L135.338 68.7487L78.6644 168.5C77.5641 170.544 76.8246 172.762 76.4786 175.058C76.0224 177.591 76.3095 180.202 77.3049 182.575C77.4523 182.932 77.6215 183.279 77.8114 183.615C79.5175 186.547 83.1429 190.039 91.14 190.039H196.703C198.382 190.039 206.566 189.692 210.351 183.241ZM143.948 83.89L195.77 175.058H92.153L143.948 83.89Z",
    fill: "#2F495E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuxtJs);
export default __webpack_public_path__ + "static/media/nuxtJS.6dcfb7a92429274a8ec93aa8332d506d.svg";
export { ForwardRef as ReactComponent };